'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:ActivityTypeCatalogService
 * @description
 * # ActivityTypeCatalogService
 * Controller of the thothAppApp
 */
angular.module('thothApp.services')
  .factory('ActivityTypeCatalog', ['$http', 'domain', 'BaseService', function ($http, domain, BaseService) {
    var BASE_ACTIVITY_URL = domain.name + '/api/v1/activity_type_catalogs/';
    var baseService = new BaseService();
    var activityTypeCatalog = [
      {
        id: 1, summaryName: "PY", summaryExtendedName: "ADM",
        name: "Administración de Proyecto",
        description: "Validaciones, Verificaciones, Seguimiento a Actividades, actividades relacionadas a la administración de proyectos. Todas las reuniones con el cliente que no sean parte del análisis, desarrollo, pruebas e implementación."
      },
      {
        id: 2, summaryName: "AN", summaryExtendedName: "ANL",
        name: "Análisis",
        description: "Todas las actividades relacionadas a la elaboración de análisis del proyecto, investigación (Sesiones de dudas con cliente o internas) y documentación (PT y documento de alcance), aprobaciones internas de documentos. (sólo aplica antes de empezar el desarrollo o en caso de que haya un cambio durante el proyecto)"
      },
      {
        id: 3, summaryName: "DE", summaryExtendedName: "DEV",
        name: "Desarrollo",
        description: "Construcción, Registro de Rastreo, Compilación, Revisión de vulnerabilidades de código"
      },
      {
        id: 4, summaryName: "PR", summaryExtendedName: "TST",
        name: "Pruebas",
        description: "Todas las pruebas que se realicen dentro del proyecto (plan de pruebas, internas, externas, ejecución del plan de pruebas, pruebas de integración)."
      },
      {
        id: 7, summaryName: "IM", summaryExtendedName: "IMP",
        name: "Implementación",
        description: "Instalación a clientes nuevos."
      },
      {
        id: 8, summaryName: "IN", summaryExtendedName: "SOP",
        name: "Soporte",
        description: "Interno, Externo a ambientes productivos. Son todas las llamadas, mensajes o correos, o reuniones para resolver dudas, problemas o consultas que NO involucran un desarrollo."
      },
      {
        id: 9, summaryName: "DC", summaryExtendedName: "DOC",
        name: "Documentación",
        description: "Toda la documentación (manuales, evidencias de pruebas, DAL) que tenga que ver con un proyecto o sistema."
      },
      {
        id: 10, summaryName: "AV", summaryExtendedName: "ADV",
        name: "Administración de versiones",
        description: "Gestión de assemblyinfo y changelog al preparar versión, Publicación en repositorio dedicado (GIT), Merge de branches, Gestión de versiones una vez pasa a producción, merge de DEV a QA y a PROD, Generación de HASHES, paquete de envío."
      },
      {
        id: 13, summaryName: "AC", summaryExtendedName: "ACO",
        name: "Acompañamiento",
        description: "Cualquier tipo de acompañamiento al cliente en pruebas o instalación de versión relacionado a un proyecto en cualquiera de sus ambientes antes de liberar a producción."
      },
      {
        id: 14, summaryName: "CA", summaryExtendedName: "PTC",
        name: "Planeación Técnica",
        description: "Alta de tickets Azure, Kickoff proyecto, Kickoff técnico, branches y fuentes."
      },
      {
        id: 6, summaryName: "CI", summaryExtendedName: "CCI",
        name: "Capacitación SCISA",
        description: "Capacitación interna a empleados, cursos de capacitación, etc."
      },
      {
        id: 5, summaryName: "CE", summaryExtendedName: "CCE",
        name: "Capacitación Cliente",
        description: "Capacitación a cliente y todas las dudas que se resuelvan al cliente."
      },
      {
        id: 11, summaryName: "MT", summaryExtendedName: "OTR",
        name: "Otros",
        description: "Eventos diversos que no pertenecen a las categorías de eventos de oficina o trabajo con clientes. Incluye actividades generales o ocasionales sin un propósito profesional específico relacionado con clientes o tareas de oficina."
      },
      {
        id: 12, summaryName: "EO", summaryExtendedName: "OFI",
        name: "Eventos de Oficina",
        description: "Cualquier evento presencial o en línea que sea de la oficina o que no sea relacionado con ningún trabajo de un cliente."
      }
    ];

    var normalizeText = function(text) {
      return String(text || '').normalize('NFD').replace(/\p{M}/gu, '').toUpperCase().trim();
    };

    baseService.initialize({
      baseUrl: BASE_ACTIVITY_URL,
      baseModelName: 'activity_type_catalog'
    });

    baseService.error = function(error) {
      baseService.baseError(error);
    };

    baseService.getActivityTypesCatalogSummary = function() {
      return activityTypeCatalog;
    };

    // Un codigo se busca completo; el nombre, desde tres letras, para que "PR" no traiga todo lo que diga "proyecto".
    baseService.searchGlossary = function(text) {
      var search = normalizeText(text);
      if (!search) {
        return activityTypeCatalog;
      }
      return activityTypeCatalog.filter(function(catalog) {
        return catalog.summaryName === search ||
          catalog.summaryExtendedName === search ||
          (search.length >= 3 && normalizeText(catalog.name).indexOf(search) !== -1);
      });
    };

    return baseService;
  }]);
